import { PropsWithChildren } from 'react'

import { UseDisclosureReturn } from '@chakra-ui/react'
import { Drawer, Popover } from '@verbit-ai/verbit-ui-library'

import { useResponsiveContainer } from 'src/contexts/ResponsiveContainerContext'
import { DownloadOption } from 'src/hooks/useDownloadOptions'

import * as S from './styles'

type DownloadControlProps = PropsWithChildren &
    Pick<UseDisclosureReturn, 'isOpen' | 'onOpen' | 'onClose'> & {
        options: DownloadOption[]
    }

export const DownloadControl = (props: DownloadControlProps) => {
    const { children, isOpen, onOpen, onClose, options } = props
    const { isMediumContainer, containerRef } = useResponsiveContainer()

    const selectOption = (option: DownloadOption) => {
        option.action()
        onClose()
    }

    const downloadPanel = () => (
        <S.DownloadPanel>
            <S.DownloadOptionList role="list">
                {options.map((option) => (
                    <S.DownloadOptionItem key={option.labelInList}>
                        <S.DownloadOption onClick={() => selectOption(option)}>{option.labelInList}</S.DownloadOption>
                    </S.DownloadOptionItem>
                ))}
            </S.DownloadOptionList>
        </S.DownloadPanel>
    )

    return isMediumContainer ? (
        <Drawer isOpen={isOpen} onClose={onClose} placement="bottom" autoFocus={false} portalProps={{ containerRef }}>
            {downloadPanel()}
        </Drawer>
    ) : (
        <Popover
            isOpen={isOpen}
            onOpen={onOpen}
            onClose={onClose}
            triggerEl={children}
            trigger="click"
            placement="bottom-end"
            boxShadow="verbit_floating_action_button_shadow"
            contentWidth="unset">
            {downloadPanel()}
        </Popover>
    )
}
